var _defs, _polygon, _polygon2, _rect, _rect2, _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconMicrosoftPpt(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    "data-name": "Capa 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 256 256",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#eeeded;}.cls-2{fill:#999;}.cls-3{fill:#b7b6b6;}.cls-4{fill:#ccc;}.cls-5{fill:#d0614a;}.cls-6{fill:#fff;}"))), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "42.73 0.26 42.73 255.65 191.71 255.65 255.56 191.8 255.56 0.26 42.73 0.26"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "191.71 191.31 191.71 255.65 255.56 191.31 191.71 191.31"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 77.59,
    y: 131.19,
    width: 141.12,
    height: 11.12
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 77.59,
    y: 157.25,
    width: 141.12,
    height: 11.12
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M145.15,17.78A49.24,49.24,0,1,0,194.38,67H145.15Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M151.14,11.48V60.72h49.24A49.24,49.24,0,0,0,151.14,11.48Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M0,55.5v145H145V55.5Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M76.32,79.3a28.41,28.41,0,0,1,12.62,2.52,23.07,23.07,0,0,1,8.25,6.62,25.9,25.9,0,0,1,4.5,9.34,42.51,42.51,0,0,1,1.37,10.71,35,35,0,0,1-2.25,13.1,23.83,23.83,0,0,1-6.28,9.14,26.27,26.27,0,0,1-9.75,5.32,42.87,42.87,0,0,1-12.69,1.77H61.59V176.7H41.94V79.3Zm-6,44.06a13,13,0,0,0,9.48-3.54q3.61-3.55,3.61-11c0-4.92-1-8.64-3.13-11.19s-5.6-3.82-10.51-3.82H61.59v29.6Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMicrosoftPpt);
export default __webpack_public_path__ + "static/media/icon-microsoft-ppt.c3146c31.svg";
export { ForwardRef as ReactComponent };